import DepositSchedulesPage from './pages/DepositSchedulesPage'
import WithdrawSchedulesPage from './pages/WithdrawSchedulesPage'
import CreateDepositSchedulePage from './pages/CreateDepositSchedulePage'
import CreateWithdrawSchedulePage from './pages/CreateWithdrawSchedulePage'
import EditSchedulePage from './pages/EditSchedulePage'

export default [
	{
		path: '/operator/transaction-settings/deposit',
		element: <DepositSchedulesPage />,
	},
	{
		path: '/operator/transaction-settings/deposit/create',
		element: <CreateDepositSchedulePage />,
	},
	{
		path: '/operator/transaction-settings/withdraw',
		element: <WithdrawSchedulesPage />,
	},
	{
		path: '/operator/transaction-settings/withdraw/create',
		element: <CreateWithdrawSchedulePage />,
	},
	{
		path: '/operator/transaction-settings/schedules/edit/:id',
		element: <EditSchedulePage />,
	},
]
